export const texts = {
  jobsiteReady: {
    de: 'Jobsite ist fertig.',
    en: 'The jobsite is ready.'
  },
  jobsiteReadyCta: {
    de: 'Jetzt ansehen',
    en: 'View now'
  },
  jobsiteContent: {
    de: 'Jobsite-Inhalte',
    en: 'Jobsite content'
  },
  description: {
    de: 'Stellenbeschreibung',
    en: 'Job description'
  },
  descriptionHint: {
    de: 'Wird auf der Jobsite als Beschreibung der Aufgabe angezeigt.',
    en: 'Shown on the jobsite as the description of the role.'
  },
  highlights: {
    de: 'Highlights',
    en: 'Highlights'
  },
  highlightsHint: {
    de: 'Ein Highlight pro Zeile. Wird auf der Jobsite unter "Ihre Vorteile" angezeigt.',
    en: 'One highlight per line. Shown on the jobsite under "Your benefits".'
  },
  discard: {
    de: 'Verwerfen',
    en: 'Discard'
  },
  save: {
    de: 'Speichern',
    en: 'Save'
  },
  noCandidates: {
    de: 'Starte das Projekt, um Bewerbungen zu erhalten.',
    en: 'No applicants yet'
  },
  outreach: {
    title: {
      de: 'Ansprache',
      en: 'Outreach'
    },
    totalContacted: {
      de: 'Ansprachen',
      en: 'Total contacted'
    },
    clicks: {
      de: 'Klicks',
      en: 'Clicks'
    },
    applications: {
      de: 'Bewerbungen',
      en: 'Applications'
    },
    contacted: {
      de: 'Ansprachen (kumuliert)',
      en: 'Contacted (cumulated)'
    },
    target: {
      de: 'Ziel',
      en: 'Target'
    }
  },
  feedback: {
    title: {
      de: 'Feedback von Kandidat:innen',
      en: 'Feedback from candidates'
    },
    rejectReasons: {
      de: 'Absagegründe',
      en: 'Reasons for rejection'
    },
    rejections: {
      de: 'der Absagen',
      en: 'of rejections'
    },
    messages: {
      de: 'Beispiele aus Antworten',
      en: 'Examples from replies'
    },
    // the choices of the rejection question in the chat (RejectReasonChoices)
    reasons: {
      tasks: { de: 'Aufgaben', en: 'Responsibilities' },
      salary: { de: 'Gehalt', en: 'Salary' },
      location: { de: 'Standort', en: 'Location' },
      employer: { de: 'Arbeitgeber', en: 'Employer' },
      career_level: { de: 'Karrierelevel', en: 'Career level' },
      timing: { de: 'Zeitpunkt', en: 'Timing' },
      other: { de: 'Sonstiges', en: 'Other' }
    }
  }
};
